import styled from '@emotion/styled'
import { WarningRounded } from '@ticketswap/comets'
import { useToast, Toast, space, color } from '@ticketswap/solar'
import { useEffect, useRef } from 'react'

const IconContainer = styled.span`
  color: ${color.mars};
  display: inline-block;
  margin-right: ${space[8]};
`

function NetworkStatus() {
  const { notify } = useToast()
  const reset = useRef(() => {})

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined'

    function handleStatusChange({ type }) {
      if (type === 'offline') {
        notify(remove => {
          reset.current = remove
          return (
            <Toast persist>
              <IconContainer>
                <WarningRounded size={24} />
              </IconContainer>
              You are offline
            </Toast>
          )
        })
      } else {
        reset.current()
      }
    }

    if (isBrowser) {
      window.addEventListener('online', handleStatusChange)
      window.addEventListener('offline', handleStatusChange)
    }

    return () => {
      if (isBrowser) {
        window.removeEventListener('online', handleStatusChange)
        window.removeEventListener('offline', handleStatusChange)
      }
    }
  }, [notify])

  return null
}

export default NetworkStatus
